import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthenticationService } from '@home/src/app/core/services/Auth/authservice';
import { GlobalService } from '@home/src/app/core/services/global/global.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-support',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './support.component.html',
  styleUrl: './support.component.css',
})
export class SupportComponent implements OnInit, OnDestroy {
  private readonly unsubscribe$ = new Subject<void>();

  nadaEmail: string = 'customerservice@nada.org';
  nadaPhone: string = '800-557-6232';

  isSendingMail: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';
  sendButtonStatus: 'Send' | 'Please Wait...' = 'Send';

  authUser: any;
  subject: string = '';
  message: string = '';

  constructor(
    private authService: AuthenticationService,
    private globalService: GlobalService,
  ) {}

  ngOnInit() {
    this.authService.fincomData$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((state: any) => (this.authUser = state));
  }

  async onSendEmail() {
    if (!this.message || !this.subject) {
      this.errorMessage = 'Please enter a subject and message to send email';
      return;
    }
    this.errorMessage = '';
    this.successMessage = '';
    this.isSendingMail = true;
    this.sendButtonStatus = 'Please Wait...';
    const payload = {
      subject: this.subject,
      message: this.message,
      userEmail: this.authUser.email,
      userName: `${this.authUser.firstName} ${this.authUser.lastName}`,
    };
    try {
      const response = await this.globalService.sendMailForSupport(payload);
      if (response.data.isSuccess) {
        this.successMessage =
          response.data.message || 'Email sent successfully';
        this.globalService.showToast(this.successMessage, 'success');
        this.message = '';
        this.subject = '';
      } else {
        this.errorMessage =
          response.data.message || 'Error sending email. Please try later';
        this.globalService.showToast(this.errorMessage, 'error');
      }
    } catch (error: any) {
      this.errorMessage =
        error?.message || 'Unable to send email. Please try later';
      this.globalService.showToast(this.errorMessage, 'error');
      console.log(error);
    } finally {
      this.isSendingMail = false;
      this.sendButtonStatus = 'Send';
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.complete();
  }
}
